import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import { exact } from "prop-types";
import ViewProject from "pages/Dashboard/ViewProject";
import LeadIndex from "pages/Lead/LeadIndex";
import AddLead from "pages/Lead/AddLead";
import EditLead from "pages/Lead/EditLead";
import ViewLead from "pages/Lead/ViewLead";
import CustomerIndex from "pages/Customer/CustomerIndex";
import ProposalIndex from "pages/Proposal/ProposalIndex";
import ContractIndex from "pages/Contract/ContractIndex";
import ProjectIndex from "pages/Project/ProjectIndex";
import SupportIndex from "pages/Support/SupportIndex";
import HostingIndex from "pages/Hosting/HostingIndex";
import ZtplInvoice from "pages/Invoice/ZtplInvoice";
import ZithasInvoice from "pages/Invoice/ZithasInvoice";
import ViewZtplInvoice from "pages/Invoice/ViewZtplInvoice";
import FinanceIndex from "pages/MyAccount/FinanceIndex";
import SupportPage from "pages/SupportPage/SupportPage";
import ViewContract from "pages/Contract/ViewContract";
import Viewproposal from "pages/Proposal/View-proposal";
import CalenderIndex from "pages/Calendar/CalenderIndex2";
import configure from "configure";

const authProtectedRoutes = [
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}/dashboard`,
    exact: true,
    component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}/viewProject`,
    exact: true,
    component: <ViewProject />,
  },
  {
    path: `${configure.appUrl}/support`,
    exact: true,
    component: <SupportIndex />,
  },

  // Lead Page
  {
    path: `${configure.appUrl}/lead-section`,
    exact: true,
    component: <LeadIndex />,
  },
  {
    // path:"/add_lead",
    path: `${configure.appUrl}/add-lead`,
    exact: true,
    component: <AddLead />,
  },
  {
    path: `${configure.appUrl}/edit-lead/:id`,
    exact: true,
    component: <EditLead />,
    type: "edit",
  },
  {
    path: `${configure.appUrl}/view-lead/:id`,
    exact: true,
    component: <ViewLead />,
  },

  // Customer Page
  {
    path: `${configure.appUrl}/customer-section`,
    exact: true,
    component: <CustomerIndex />,
  },

  // Customer Page
  {
    path: `${configure.appUrl}/proposal-section`,
    exact: true,
    component: <ProposalIndex />,
  },
  {
    path: `${configure.appUrl}/view-proposal/:id`,
    exact: true,
    component: <Viewproposal />,
  },

  // Contract Page
  {
    path: `${configure.appUrl}/contract-section`,
    exact: true,
    component: <ContractIndex />,
  },
  {
    path: `${configure.appUrl}/view-contract/:id`,
    exact: true,
    component: <ViewContract />,
  },

  // Project Page
  {
    path: `${configure.appUrl}/project-section`,
    exact: true,
    component: <ProjectIndex />,
  },

  // Hosting Page
  {
    path: `${configure.appUrl}/hosting-section`,
    exact: true,
    component: <HostingIndex />,
  },

  // Invocie Page
  // Zithas Invoice
  {
    path: `${configure.appUrl}/ztpl-invoice`,
    exact: true,
    component: <ZtplInvoice />,
  },
  // Zithas private Tech Page
  {
    path: `${configure.appUrl}/zithas-invoice`,
    exact: true,
    component: <ZithasInvoice />,
  },
  {
    path: `${configure.appUrl}/finance/view/:type/:id`,
    component: <ViewZtplInvoice />,
    module_id: "45",
    type: "view",
  },

  // Finance Page
  {
    path: `${configure.appUrl}/finance-section`,
    exact: true,
    component: <FinanceIndex />,
  },

  // Support Page
  {
    path: `${configure.appUrl}/support-section`,
    exact: true,
    component: <SupportPage />,
  },
  {
    path: `${configure.appUrl}/calendar`,
    exact: true,
    component: <CalenderIndex />,
  },
];

const publicRoutes = [
  { path: `${configure.appUrl}/logout`, component: <Logout /> },
  { path: `${configure.appUrl}/login`, component: <Login /> },
  { path: `${configure.appUrl}/forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}/register`, component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
